import { Image, Spinner, Text } from "@/ui/core";
import { Box, HStack, StatusBarPadding } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";

interface SMTUploadBannerProps {
  photoUri?: string;
}

const SMTUploadBanner = ({ photoUri }: SMTUploadBannerProps) => {
  return (
    <Box>
      <StatusBarPadding backgroundColor={ColorToken.Primary100} />
      <Box
        backgroundColor={ColorToken.Primary100}
        paddingHorizontal={LayoutToken.ContentPaddingHorizontal}
        paddingVertical={12}
      >
        <HStack alignItems="center" gap={12} justifyContent="flex-start">
          {photoUri && (
            <Box
              borderColor={ColorToken.NeutralBackgroundPrimary}
              borderRadius={6}
              borderWidth={2}
              overflow="hidden"
            >
              <Image
                contentFit="cover"
                size={{ height: 40, width: 40 }}
                testID="smt-upload-banner-thumbnail"
                uriSource={photoUri}
              />
            </Box>
          )}
          <Spinner color={ColorToken.NeutralBackgroundPrimary} size="small" />
          <Text
            color={ColorToken.NeutralBackgroundPrimary}
            testID="smt-upload-banner-message"
            variant="bodyMedium"
          >
            Uploading photo…
          </Text>
        </HStack>
      </Box>
    </Box>
  );
};

export type { SMTUploadBannerProps };
export default SMTUploadBanner;
